import { render, staticRenderFns } from "./FormReceive.vue?vue&type=template&id=7f2373f6&"
import script from "./FormReceive.vue?vue&type=script&lang=js&"
export * from "./FormReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports